import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import {
  useSubscriptionSetupContext,
} from 'Views/Onboarding/Pages/SubscriptionSetup/SubscriptionSetupContext';
import { currency, currencyFromCents } from 'Helpers/Formats';
import SubscriptionPaymentSummaryItem from '../SubscriptionPaymentSummaryItem';

const styles = (theme) => ({
  root: {
    width: '100%',
    padding: theme.spacing(2, 0),
  },
  totalItem: {
    paddingTop: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.grey[200]}`,
  },
  proratedFeeInfoText: {
    textAlign: 'right',
    marginTop: theme.spacing(-1),
    marginBottom: theme.spacing(2),
  },
});

const SubscriptionPaymentSummary = ({
  className,
  classes,
}) => {
  const { billingInformationCollection } = useSubscriptionSetupContext();

  const [billingInformationResource] = billingInformationCollection;
  const serviceAgreementLineItems = billingInformationResource.attr('serviceAgreementLineItems')?.resources()?.list() || [];

  const lineItems = serviceAgreementLineItems
    .map(lineItem => (<SubscriptionPaymentSummaryItem
      key={`line-item-${lineItem.id()}`}
      name={'line-item'}
      label={lineItem.attr('description')}
      lineItems={[
        {
          name: `line-item-${lineItem.id()}`,
          label: currencyFromCents(+lineItem.attr('amountInCents'), false),
        },
      ]}
    />));

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      {lineItems}

      {/* -------- TOTAL -------- */}
      <SubscriptionPaymentSummaryItem
        className={classes.totalItem}
        name={'total-due-label'}
        label={'Total'}
        lineItems={[{
          name: 'total-due-amount',
          label: currency(billingInformationResource.attr('total'), false),
        }]}
        LabelTypographyProps={{
          color: 'primaryGray',
          variant: 'h4',
        }}
        ValueTypographyProps={{
          color: 'primaryGray',
          variant: 'h4',
        }}
      />

      {/* -------- TOTAL DUE TODAY -------- */}
      <SubscriptionPaymentSummaryItem
        name={'due-today-label'}
        label={'Due Today'}
        lineItems={[{
          name: 'due-today-amount',
          label: currency(billingInformationResource.attr('totalDueToday'), false),
        }]}
        LabelTypographyProps={{
          color: 'primary',
          variant: 'h4',
        }}
        ValueTypographyProps={{
          color: 'primary',
          variant: 'h4',
        }}
      />
    </Box>
  );
};

SubscriptionPaymentSummary.defaultProps = {
  className: '',
};

SubscriptionPaymentSummary.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  // billingInformationCollection: PropTypes.object.isRequired,
};

export default withStyles(styles)(SubscriptionPaymentSummary);
